import React, { useState } from "react";
import OrdenesLista from "../lista/OrdenLista.js";
import OrdenCanasta from "../canastaOrdenes/CanastaOrdenes.js";
import { useOrdenes } from "../../../../contexto/provider/OrdenesContext.js";

import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import "./OrdenLayout.css";

export default function ProductosLayout() {
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const { ordenesSeleccionadas, actualizarSeleccion } = useOrdenes();

  function agregarProducto(producto) {
    actualizarSeleccion([...ordenesSeleccionadas, producto]);
    setMostrarPopup(true);
    setTimeout(() => setMostrarPopup(false), 2000);
  }

  return (
    <div className="layout-ordenes">
      <TituloModulo titulo="Ordenes disponibles" />

      <OrdenCanasta />
      <OrdenesLista onProductoSeleccionado={agregarProducto} />

      {mostrarPopup && (
        <div className="popup-agregado">Producto agregado al carrito</div>
      )}
    </div>
  );
}
